module.exports = "<div class=\"__logo\"></div>\r\n<div style=\"font-size:24px; font-weight: bold; margin: 30px 0 10px;\">KENDU</div>\r\n<a class=\"kd-button kd-button--raised kd-button--primary __button\" href=\"/dashboard\">\r\n  Ingresar\r\n</a>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/inicio/components/template.html
// module id = 255
// module chunks = 0